import { Field } from 'components/Field'
import { CheckboxFieldProps, checkboxFieldStyles } from 'components/FormFields'
import { FormFieldProps } from 'components/FormFields'
import { Field as FormikField, FieldConfig } from 'formik'
import React from 'react'
import styled, { css } from 'styled-components'
import { FormikFieldStatus } from 'components/Formik/Formik.field.status'

const formikCheckboxStyles = css`
	${checkboxFieldStyles}
`

const FormikCheckboxView = styled.div`
	${formikCheckboxStyles}
`

export type FormikCheckboxProps = Omit<FieldConfig<boolean>, 'type'> & {
	name: string
	config: Omit<FormFieldProps, 'labelPos'> & {
		labelPos: CheckboxFieldProps['labelPos']
	}
	className?: string
}

export const FormikCheckbox = ({ name, config, className, ...props }: FormikCheckboxProps) => {
	const { labelPos = 'right', ...fieldProps } = config
	return (
		<FormikCheckboxView className={`formik-checkbox${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} labelPos={labelPos} name={name}>
				<FormikField {...props} name={name} type={'checkbox'} as={null} />
				<FormikFieldStatus name={name} />
			</Field>
		</FormikCheckboxView>
	)
}
